import { render, staticRenderFns } from "./RestaurantStep.vue?vue&type=template&id=5c00cf77&"
import script from "./RestaurantStep.vue?vue&type=script&lang=js&"
export * from "./RestaurantStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports